import { BankReceiptEntityService } from '@views/pages/apps/settings/bank-receipts/services/bank-receipt-entity.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';

@Injectable()
export class BankReceiptResolver implements Resolve<boolean> {

    constructor(private bankReceiptEntityService: BankReceiptEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.bankReceiptEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.bankReceiptEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
